import React, { useEffect } from 'react';
import { defualtRedirectUrlReferrer } from '../Utils/authHelper';

interface LogoutPageProps {
  auth: any;
}

const LogoutPage: React.FC<LogoutPageProps> = ({ auth }) => {
  /**
   * Performs logout operation based on URL parameters.
   * Handles both normal logout and force logout scenarios.
   */
  const performLogout = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const referrer = urlParams.get('referrer') || defualtRedirectUrlReferrer;
      const forceSignOut = urlParams.get('forceSignOut') === 'true';
      const overrideUrl = urlParams.get('overrideUrl');

      console.log({
        message: 'LogoutPage: Starting logout with referrer:',
        referrer,
        forceSignOut,
        overrideUrl,
      });

      sessionStorage.clear();
      localStorage.clear();
      await auth.removeUser();

      if (forceSignOut && overrideUrl) {
        await auth.signoutSilent();

        const url = new URL(overrideUrl);
        ['login_hint', 'referrer'].forEach((param) => {
          const value = url.searchParams.get(param);
          if (value) url.searchParams.set(param, value);
        });

        const finalUrl = url.toString();
        console.log('Final encoded URL:', finalUrl);
        window.location.href = finalUrl;
      } else {
        await auth.signoutRedirect({
          extraQueryParams: {
            client_id: auth.settings.client_id,
            logout_uri: decodeURIComponent(referrer),
          },
        });
      }
    } catch (error) {
      console.error('LogoutPage error:', error);
    }
  };

  useEffect(() => {
    performLogout().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LogoutPage;
